

import { generateTimeSeriesColumns, getIndexesFromNodeArray, handleUndoRowUpdates, isValidPerson, parentRowsAferRollup, 
    processSuccessorNodes, removeThisNodeAsSuccessorFromOtherRows , findColumnUsingParamsOrGridRef , getAllParentsOfANode, } from "../../helper/helpersSubModule";
import { v4 as uuidv4 } from 'uuid';
import { isStringifiedArrayWithPropName, parseAndSortValuesForPersonCol } from "../../../../helpers/ExportHelper";
import { getDetachedCellRanges, getDetachedFocusedCell } from "../EditSheetOptions/editsheetoptionshelper";
import { checkIfRollupEnabledInMDV } from "../../helper/xTablesHelper";
import { findDefaultItem, generateListDataForRollupStatus } from "../../helper/helperFunctions";


export const getIndentationStylesForExcel = () => {
    let indentClasses=[
        {
            id: `indent_one`,
            alignment: {
                indent: 0,
            },
            dataType: "String",
        },
        {
            id: `indent_two`,
            alignment: {
                indent: 4,
            },
            dataType: "String",
        },
        {
            id: `indent_three`,
            alignment: {
                indent: 6,
            },
            dataType: "String",
        },
        {
            id: `indent_four`,
            alignment: {
                indent: 8,
            },
            dataType: "String",
        },
        {
            id: `indent_five`,
            alignment: {
                indent: 10,
            },
            dataType: "String",
        },
        {  
            id: `indent_six`,
            alignment: {
                indent: 12,
            },
            dataType: "String",
        },
        {
            id: `indent_seven`,
            alignment: {
                indent: 14,
            },
            dataType: "String",
        },
        {
            id: `indent_eight`,
            alignment: {
                indent: 16,
            },
            dataType: "String",
        },
        {
            id: `indent_nine`,
            alignment: {
                indent: 18,
            },
            dataType: "String",
        },
        {
            id: `indent_ten`,
            alignment: {
                indent: 20,
            },
            dataType: "String",
        },
        {
            id: `indent_eleven`,
            alignment: {
                indent: 22,
            },
            dataType: "String",
        },
        {
            id: `indent_twelve`,
            alignment: {
                indent: 24,
            },
            dataType: "String",
        },
        {
            id: `indent_thirteen`,
            alignment: {
                indent: 26,
            },
            dataType: "String",
        },
        {
            id: `indent_fourteen`,
            alignment: {
                indent: 28,
            },
            dataType: "String",
        },
        {
            id: `indent_fifteen`,
            alignment: {
                indent: 30,
            },
            dataType: "String",
        },
        {
            id: `indent_sixteen`,
            alignment: {
                indent: 32,
            },
            dataType: "String",
        }
    ]

    return indentClasses;

}
export  const getIndentClass = (params) => {
    var indent = 0;
    var node = params.node;
    while (node && node.parent) {
      indent++;
      node = node.parent;
    }
    if(indent==1) return "indent_one"
    else if(indent==2) return "indent_two"
    else if(indent==3) return "indent_three"
    else if(indent==4) return "indent_four"
    else if(indent==5) return "indent_five"
    else if(indent==6) return "indent_six"
    else if(indent==7) return "indent_seven"
    else if(indent==8) return "indent_eight"
    else if(indent==9) return "indent_nine"
    else if(indent==10) return "indent_ten"
    else if(indent==11) return "indent_eleven"
    else if(indent==12) return "indent_twelve"
    else if(indent==13) return "indent_thirteen"
    else if(indent==14) return "indent_fourteen"
    else if(indent==15) return "indent_fifteen"
    else if(indent==16) return "indent_sixteen"
    return " indent_" + indent;
  };
  export const updateNodeWithValue=(node,gridRef,fields)=>{
    let data=node.data
    Object.keys(fields).forEach((field)=>{
        data[field]=fields[field]
        gridRef.current.api.applyTransaction({
            update:[data],
            addIndex:node.rowIndex
        })
    })
  }
  export const NumberRenderer = (params) => {
    let val = params.value !== undefined ? params.value === '' ? parseInt(0) : parseFloat(params.value) : ''
    if (!isNaN(val))
      return <div>{val}</div>
    else return <div></div>
  }
export const TimeSeriesColumngroup = ({startDate,endDate,frequency},columnDefs,valueChangedByValueGetter,allColumns,extendedDate,colDef, extensionDirection) => {
    let colId=uuidv4()
    let timeSeriesColumns=generateTimeSeriesColumns(startDate,endDate,frequency,columnDefs.length+1,colId,columnDefs,valueChangedByValueGetter,allColumns,extendedDate,colDef, extensionDirection)
    let columnGroup = {
        headerName: "TimeSeries",
        colId:colId,
        columnElasticid:colId,
        children: timeSeriesColumns,
        groupId:colId,
        block:JSON.stringify({type:'timeseries',startDate:startDate,endDate:endDate,frequency:frequency})
    }
    return columnGroup
}

export const findColumnDef = (columns, key) => {
    for (const column of columns) {
        if (column.field === key || (column.field + "_es") === key) {
            return column;
        }
        if (column.children && column.children.length > 0) {
            const childColumn = findColumnDef(column.children, key);
            if (childColumn) {
                return childColumn;
            }
        }
    }
    return null;
};
export const clearCellValue = (
    rowData,
    colDef,
    isParent,
    loggedInUser,
    rowsToProcessAfter,
    endDateColumn
) => {
    const updatedData = { ...rowData };

        let value = ''
        if (colDef.type === "shareableRollupList"&&!isParent) {
            let defaultState = colDef.defaultStatus ? JSON.parse(colDef.defaultStatus) : {
                value: 'Backlog',
                parent: 'Default Status',
                precedence: '0:0',
                rowId: 'None',
            }
            let { listData, precedenceMapping } = generateListDataForRollupStatus(JSON.parse(colDef.listData));
            let defaultItem= findDefaultItem(listData, defaultState)
            if(defaultItem) {
                defaultState = defaultItem
            }
            value = JSON.stringify({ rowId: defaultState.rowId ? defaultState.rowId : 'None', value: defaultState.value })
        }
        updatedData[colDef.field] = value;

        if (updatedData[colDef.field + "_es"]) {
            updatedData[colDef.field + "_es"] = {
                ...updatedData[colDef.field + "_es"],
                value: value,
                updatedDate: new Date().toUTCString(),
                lastUpdatedBy: loggedInUser
            };
        }

    //  Add to rowsToProcessAfter if needed
    if (
        endDateColumn &&
        colDef.field === endDateColumn.field &&
        rowData?.successorNodes
    ) {
        rowsToProcessAfter.push({
            row: updatedData,
            column: colDef
        });
    }

    return updatedData;
};

// Update row data
export const updateRowData = (dataToProcess, columns, endDateColumn, rowsToProcessAfter,isParent,loggedInUser) => {
    return Object.entries(dataToProcess).reduce((acc, [key, value]) => {
        // Make a deep copy if you're updating nested structures
        let newAcc = acc ? { ...acc } : {};
        const columnDef = findColumnDef(columns, key);
        const isRollupValid = columnDef?.rollup && (
            (columnDef.type === "date" && ["Max", "Min"].includes(columnDef.rollup)) ||
            (columnDef.type === "number" && ["Max", "Min", "Sum", "Avg"].includes(columnDef.rollup))
        );

        const isTypeValid = columnDef?.type && ( 
            columnDef?.status ||
            columnDef.type === "shareableRollupList" ||
            columnDef.type === "duration" ||
            columnDef?.block === "timeseries");

        const shouldRetainValue = isParent && columnDef?.type && (isRollupValid || isTypeValid);

        if (key.endsWith('_es') && key !== '#_es') {
            newAcc[key] = shouldRetainValue ? value : { ...value, value: '' ,updatedDate:new Date().toUTCString(),lastUpdatedBy:loggedInUser};

        }
        else if (/^Column\d+$/.test(key) || key === 'primaryCol' || (columnDef?.block)) {
            newAcc[key] = shouldRetainValue ? value : '';
        }
        else {
            newAcc[key] = value;
        }
        // Handle row updates only after `newAcc` is updated
        if (columnDef && endDateColumn && columnDef.field === endDateColumn.field && dataToProcess?.successorNodes) {
            if (dataToProcess[endDateColumn.field]) {
                // Ensure only the last occurrence for the column is retained
                const existingIndex = rowsToProcessAfter?.findIndex(
                    (entry) => entry.column.field === columnDef.field && entry.row.id === dataToProcess.id
                );

                const newRowEntry = {
                    row: newAcc, // Use the updated newAcc here
                    column: columnDef,

                };
                if (existingIndex !== -1) {
                    // Replace the existing entry
                    rowsToProcessAfter[existingIndex] = newRowEntry;
                } else {
                    // Add a new entry
                    rowsToProcessAfter.push(newRowEntry);
                }
            }
        }
        return newAcc;
    }, {});
};

// Process successor nodes
export const processRowsToProcessAfter = (rowsToProcessAfter, gridRef, endDateColumn, transactionData, prevRows,selectedNodes) => {
    if (!rowsToProcessAfter || rowsToProcessAfter.length === 0)
        return;
    else {
        rowsToProcessAfter.forEach(({ row, column }) => {
            let successorNodesArray = row?.successorNodes.split(',').filter(Boolean);

            // Filter out IDs already in transactionData
            const remainingSuccessors = successorNodesArray?.filter(
                nodeId => !selectedNodes.some(transactionRow => transactionRow.id === nodeId)
            );

            // Update successorNodes only if it changes
            if (remainingSuccessors?.length !== successorNodesArray?.length) {
                row.successorNodes = remainingSuccessors.join(',');
            }

            // Skip processing if no successors remain
            if (remainingSuccessors?.length === 0 ||!endDateColumn) return;


            const result = processSuccessorNodes(
                '',
                row,
                column,
                [row],
                gridRef,
                endDateColumn.linkedColumns.predecessorStartDate,
                endDateColumn.linkedColumns.predecessorEndDate,
                endDateColumn.linkedColumns.predecessor,
                endDateColumn.linkedColumns.duration,
                column.field,
                endDateColumn.linkedColumns.startDate
            );
            // Handle the result if applicable
            if (result?.changedSuccessorRows?.length > 0) {
                transactionData.push(...result.changedSuccessorRows);
            }
            if (result?.undoRows) {
                handleUndoRowUpdates(result.undoRows, prevRows, 'id');
            }
        });
    }

};

// Remove predecessor nodes
export const removePredecessorNodes = (updatedData, gridRef, prevRows, transactionData, undoRows,isCellDelete) => {
    // remove the predecessornodes if they exit
    if (updatedData.predecessorNodes) {
        let predecessorNodes = JSON.parse(JSON.stringify(updatedData.predecessorNodes))
        // Update nodesWithSuccessorUpdated with successor removed rows
        let successorRemovedRows = removeThisNodeAsSuccessorFromOtherRows(predecessorNodes, gridRef.current, updatedData.id, prevRows, '', transactionData)
        updatedData.predecessorNodes = '';
        if (successorRemovedRows?.nodesWithSuccessorUpdated)
        transactionData.push(...successorRemovedRows.nodesWithSuccessorUpdated);
    }
    if(!isCellDelete) undoRows.push(JSON.parse(JSON.stringify(updatedData)))
    transactionData.push(updatedData);

};

// Apply transaction and update undo/redo stacks
export const applyTransactionAndUndo = (transactionData, gridRef, prevRows, selectedNodes, setRedoStack, setUndoStack,deletedColumnDefs,startIndex,updatedParentNodesSet,isCellDelete) => {

    let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(transactionData, gridRef, '',updatedParentNodesSet, deletedColumnDefs)
    handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, prevRows, 'id');
    gridRef.current.api.applyTransactionAsync({
        update: mergedRowsAfterRollupAndPredecessorChange,
    })

    // Update redo and undo stacks
    setRedoStack([{
        type: 'row',
        action: 'transaction',
        indexes:selectedNodes? selectedNodes[0]?.rowIndex:startIndex,
        previousRows: mergedRowsAfterRollupAndPredecessorChange,
        cellRows: prevRows,
        dontSelectCell: true
    }]);

    setUndoStack([{
        type: 'row',
        action: 'transaction',
        indexes:selectedNodes? selectedNodes[0]?.rowIndex:startIndex,
        previousRows: prevRows,
        cellRows: mergedRowsAfterRollupAndPredecessorChange,
        dontSelectCell: true
    }]);
};

export function makeColumnsReadOnly(columns) {
    return columns.map(col => {
      const updatedCol = {
        ...col,
        editable: false,
        rowDrag: false,
        suppressMovable:true
      };
  
      if (col.children) {
        updatedCol.children = makeColumnsReadOnly(col.children);
      }
  
      return updatedCol;
    });
  }

  export const findAssigneeColumn = (columns) => {
    for (const col of columns) {
      if (col.type === 'Assignee') {
        return col;
      }
  
      if (Array.isArray(col.children)) {
        const found = findAssigneeColumn(col.children);
        if (found) return found;
      }
    }
    return null;
  };
  export const processCellForClipboardHelper = (
    params,
    {
        gridRef,
        tracer,
        logSpan,
    }
) => {
    const span = tracer.startSpan('processCellForClipboard');
    const functionFlow = [];

    try {
        functionFlow.push('started');

        if (params.column?.colId === "#") return;

        const cellRanges = gridRef.current?.api.getCellRanges();
        const isRowCopy = cellRanges?.[0]?.columns?.[0]?.colId === '#';

        if (isRowCopy) return;

        if (params.node?.data?.checkinagent || params.node?.data?.isAzureRow)
            return "";

        if (params.type === "dragCopy") return params.value;

        const column = params.api.getAllDisplayedColumns();
        const id = params.node.data.id;
        const rowIndex = params.node.rowIndex;

        const generateClipboardData = (
            value,
            id,
            rowIndex,
            format,
            cellStyle
        ) => {
            functionFlow.push('generateClipboardData');
            return [value, id, rowIndex, format, JSON.stringify(cellStyle)].join('⇔≈⊗');
        };

        const dataField =
            (params.column?.colDef.field || column[1]?.colDef.field) + "_es";

        let { format = " ", cellStyle = {}, value } =
            params.node.data[dataField] || {};

        switch (params.column?.colDef.type) {
            case "predecessor": {
                functionFlow.push('type: predecessor');
                const { indexString } =
                   getIndexesFromNodeArray(params.value, params);
                return `${indexString || ""}⇔≈⊗${id}⇔≈⊗${rowIndex}`;
            }

            case "multi dimensional value":
                functionFlow.push('type: multidimensional');
                if (isStringifiedArrayWithPropName(params.value)) {
                    return generateClipboardData(
                        params.value || "",
                        id,
                        rowIndex,
                        format,
                        cellStyle
                    );
                }
                break;

            case "person":
            case "Assignee":
                functionFlow.push('type: person');
                if (isValidPerson(params.value)) {
                    return generateClipboardData(
                        parseAndSortValuesForPersonCol(params.value) || "",
                        id,
                        rowIndex,
                        format,
                        cellStyle
                    );
                }
                break;
        }

        if (
            params.column?.field === 'primaryCol' &&
            params.node?.allChildrenCount != null &&
            params.node?.childrenAfterAggFilter?.length !== 0
        ) {
            functionFlow.push('primary bold');
            format = format.includes('bold') ? format : format + ' bold ';
        }

        const l_id =
            params.column?.colId !== "ag-Grid-AutoColumn"
                ? params.node.data.id
                : params.node.data.l_id;

        const result = generateClipboardData(value, l_id, rowIndex, format, cellStyle);

        logSpan(
            'processCellForClipboard-generateClipboardData',
            span.spanContext(),
            'INFO',
            result
        );

        functionFlow.push('finished');
        return result;
    } finally {
        span.setAttribute(
            'processCellForClipboard.functionFlow',
            functionFlow.join(' → ')
        );
        span.end();
    }
};

export const isRollupColumn = (columnDef) => {
    if (!columnDef) return false;

    let isMDVRollupApplicable = false;

    if (columnDef.type === "multi dimensional value") {
        const listData = columnDef.listData;

        isMDVRollupApplicable =
            typeof listData === "string"
                ? checkIfRollupEnabledInMDV(JSON.parse(listData))
                : checkIfRollupEnabledInMDV(listData);
    }
    const subTaskDependentTypes = ['Max', 'Min','Sum','Avg', 'shareableRollupList', 'status', 'duration','predecessor'];
  
    return (
        subTaskDependentTypes?.includes(columnDef?.rollup) ||
        subTaskDependentTypes?.includes(columnDef?.type) ||
        (columnDef?.type === "multi dimensional value" && columnDef?.block) ||
        (columnDef?.type === "multi dimensional value" && isMDVRollupApplicable)
    );
};

export function handleDeleteKey({
    e,
    gridRef,
    loggedInUser,
    user,
    setRedoStack,
    setUndoStack,
}) {

    const api = e.api;
    const ranges = api.getCellRanges();
    var focusedCell = gridRef?.current?.api?.getFocusedCell();
 
    if ((!ranges && !focusedCell)||e.colDef.colId!=="ag-Grid-AutoColumn") return;
    let rangesToProcess = ranges && ranges.length ? ranges : [];

    if ((!ranges || ranges.length === 0) && focusedCell) {
        const focusedNode = api.getDisplayedRowAtIndex(focusedCell.rowIndex);
        const focusedColumn = focusedCell.column;

        if (focusedNode && focusedColumn) {
            rangesToProcess = [
                {
                    startRow: { rowIndex: focusedCell.rowIndex },
                    endRow: { rowIndex: focusedCell.rowIndex },
                    columns: [focusedColumn],
                },
            ];
        }
    }

    let undoRows = [];
    let transactionData = [];
    let prevRows = [];
    let endDateColumn;
    let predecessorColumn;
    let startIndex;

    const rowsToUpdate = new Map();
    const affectedColumns = new Map();
    const rollupColumns = new Map();
    const rowsToProcessAfter = [];
    rangesToProcess.forEach(range => {
        const start = Math.min(range.startRow.rowIndex, range.endRow.rowIndex);
        const end = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);
        startIndex = start;

        range.columns.forEach(col => {
            const colDef = col.getColDef();
            if (!colDef?.field) return;

            if (colDef.type === 'predecessor') {
                predecessorColumn = colDef;

                endDateColumn =
                    predecessorColumn?.linkedColumns?.predecessorEndDate
                        ? findColumnUsingParamsOrGridRef(
                            gridRef.current,
                            'date',
                            predecessorColumn.linkedColumns.predecessorEndDate
                        )
                        : '';
            }

            affectedColumns.set(colDef.field, colDef);

            if (isRollupColumn(colDef)) {
                rollupColumns.set(colDef.field, colDef);
            }
        });

        for (let rowIndex = start; rowIndex <= end; rowIndex++) {
            const rowNode = api.getDisplayedRowAtIndex(rowIndex);
            if (!rowNode?.data) continue;

            if (!prevRows.some(prev => prev.id === rowNode.data.id)) {
                prevRows.push(JSON.parse(JSON.stringify(rowNode.data)));
            }

            let updatedData =
                rowsToUpdate.get(rowNode.id) || { ...rowNode.data };

            affectedColumns.forEach(colDef => {
                updatedData = clearCellValue(
                    updatedData,
                    colDef,
                    rowNode?.allChildrenCount > 0,
                    loggedInUser || user,
                    rowsToProcessAfter,
                    endDateColumn
                );
            });
            removePredecessorNodes(
                updatedData,
                gridRef,
                prevRows,
                transactionData,
                undoRows,
                true
            );

            rowsToUpdate.set(rowNode.id, updatedData);
        }
    });

    processRowsToProcessAfter(
        rowsToProcessAfter,
        gridRef,
        endDateColumn,
        transactionData,
        prevRows,
        ''
    );

    const columns = Array.from(rollupColumns.values());

    if (columns.length) {
        const updatedParentNodesSet = new Set();

        gridRef.current.api.applyTransactionAsync({
            update: transactionData,
        })
        if (transactionData?.length) {
            transactionData.forEach(row => {
                // 1️ node itself if it has children
                let node = gridRef.current.api.getRowNode(row.id);
                if ((node.allChildrenCount ?? 0) > 0) {
                    updatedParentNodesSet.add(node);
                }

                // 2 all its parents
                const parents = getAllParentsOfANode(node) || [];
                parents.forEach(parent => {
                    updatedParentNodesSet.add(parent);
                });
            });
        }
        setTimeout(() => {
            applyTransactionAndUndo(
                transactionData,
                gridRef,
                prevRows,
                '',
                setRedoStack,
                setUndoStack,
                Array.from(rollupColumns.values()),
                startIndex,
                updatedParentNodesSet,
                true
            );
        }, 100);

    } else if (rowsToUpdate.size > 0) {
        api.applyTransaction({
            update: transactionData
        });

        setRedoStack([{
            type: 'row',
            action: 'transaction',
            indexes: startIndex,
            previousRows: transactionData,
            cellRows: prevRows,
            dontSelectCell: true
        }]);

        setUndoStack([{
            type: 'row',
            action: 'transaction',
            indexes: startIndex,
            previousRows: prevRows,
            cellRows: transactionData,
            dontSelectCell: true
        }]);
    }
}
// Applies style for a single column on a row. No snapshot — caller owns snapshot timing.
const applyStyleToCell = (rowNode, colDef, isCellStyleRef, gridRef, loggedInUser, user) => {
    let cell = rowNode.data[colDef.field + '_es'];
    if (!cell) {
        rowNode.data[colDef.field + '_es'] = {
            cellStyle: isCellStyleRef.current.cellStyles,
            format: isCellStyleRef.current.format,
        };
        cell = rowNode.data[colDef.field + '_es'];
    } else {
        cell.cellStyle = isCellStyleRef.current.cellStyles;
        cell.format = isCellStyleRef.current.format;
    }
    cell.lastUpdatedBy = loggedInUser || user;
    gridRef.current.api.refreshCells({ rowNodes: [rowNode], columns: [colDef.colId] });
};

// Applies format painter styles to a row across the given columns.
// Snapshot is taken ONCE before any column is touched, so previousRows captures the true original.
const applyStoredStyleToRow = (rowNode, colDefs, isCellStyleRef, gridRef, loggedInUser, user) => {
    const prevRow = JSON.parse(JSON.stringify(rowNode.data));
    colDefs.forEach(colDef => applyStyleToCell(rowNode, colDef, isCellStyleRef, gridRef, loggedInUser, user));
    return { index: rowNode.rowIndex, prevRow, rowData: rowNode.data };
};

export const copyStyleAndFormatHelper = (_e, gridRef, setFormatPainterActive, isCellStyleRef, setUndoStack, loggedInUser, user) => {
    if (!isCellStyleRef.current || isCellStyleRef.current.formatPainterActive !== true) return;

    const api = gridRef.current.api;
    // Use api.getCellRanges() directly — getDetachedCellRanges translates to sourceRowIndex
    // which can be null for grouped rows, collapsing the range to row 0 only.
    const cellRanges = api.getCellRanges();
    const undoBatch = [];

    const focusedCell = getDetachedFocusedCell(gridRef);
    const colDef = focusedCell?.column?.colDef;

    if (cellRanges?.length > 0) {
        // Cell range selection (drag-select or shift+click on cells)
        cellRanges.forEach(range => {
            const startIdx = Math.min(range.startRow.rowIndex, range.endRow.rowIndex);
            const endIdx = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);
            const colDefs = range.columns.map(col => col.colDef);
            for (let rowIdx = startIdx; rowIdx <= endIdx; rowIdx++) {
                const rowNode = api.getDisplayedRowAtIndex(rowIdx);
                if (!rowNode?.data) continue;
                undoBatch.push(applyStoredStyleToRow(rowNode, colDefs, isCellStyleRef, gridRef, loggedInUser, user));
            }
        });
    } else if (api.getSelectedNodes()?.length > 1) {
        // Row selection (multiple rows selected via checkboxes or row-header drag)
        // Apply to the focused column across all selected rows
        if (colDef) {
            api.getSelectedNodes().forEach(rowNode => {
                if (!rowNode?.data) return;
                undoBatch.push(applyStoredStyleToRow(rowNode, [colDef], isCellStyleRef, gridRef, loggedInUser, user));
            });
        }
    } else {
        // Single cell fallback
        if (!focusedCell) return;
        const focusedNode = api.getModel().rootNode.allLeafChildren[focusedCell.rowIndex];
        if (focusedNode?.data && colDef) {
            undoBatch.push(applyStoredStyleToRow(focusedNode, [colDef], isCellStyleRef, gridRef, loggedInUser, user));
        }
    }

    if (undoBatch.length > 0) {
        setUndoStack([{
            type: 'row',
            action: 'transaction',
            index: undoBatch[0].index,
            previousRows: undoBatch.map(e => e.prevRow),
            cellRows: undoBatch.map(e => e.rowData),
            dontSelectCell: true,
        }]);
    }
    isCellStyleRef.current = false;
    setFormatPainterActive(false);
}

export const updateWrapButtonState = ({ gridRef, selectedColumns, setIsTextWrap }) => {
    if (!gridRef?.current?.api) return;

    const api = gridRef.current.api;

    const selectedRows = api.getSelectedNodes();
    const selectedRanges = getDetachedCellRanges(gridRef);
    const focusedCell = getDetachedFocusedCell(gridRef);

    // ======================
    // 1️⃣ COLUMN MODE
    // ======================
    if (selectedColumns?.length > 0) {
        const allWrapped = selectedColumns.every(colId => {
            const column = api.getColumn(colId);
            return column?.getColDef()?.wrapText === true;
        });

        setIsTextWrap(allWrapped);
        return;
    }

    // ======================
    // 2️⃣ ROW MODE
    // ======================
    if (selectedRows?.length > 0) {
        const allColumns = api
            .getAllGridColumns()
            .filter(col => col.getColId() !== "#");

        let allWrapped = true;

        selectedRows.forEach(node => {
            const row = node.data;

            allColumns.forEach(column => {
                const field = column.getColDef().field;
                const styleKey = field + "_es";

                const isWrapped =
                    row?.[styleKey]?.cellStyle?.wrap === "true";

                if (!isWrapped) {
                    allWrapped = false;
                }
            });
        });

        setIsTextWrap(allWrapped);
        return;
    }

    // ======================
    // 3️⃣ CELL MODE
    // ======================
    if (selectedRanges?.length > 0 && focusedCell) {
        const rowData = api.getModel().rootNode.allLeafChildren;
        const field = focusedCell.column.getColDef().field;
        const styleKey = field + "_es";
        const row = rowData[focusedCell.rowIndex]?.data;

        setIsTextWrap(row?.[styleKey]?.cellStyle?.wrap === "true");
    }

    // ======================
    // 3️⃣ RANGE MODE  🔥 NEW
    // ======================
    if (selectedRanges?.length > 0) {
        const allRows = api.getModel().rootNode.allLeafChildren;
        let allWrapped = true;

        selectedRanges.forEach(range => {
            const start = Math.min(
                range.startRow.rowIndex,
                range.endRow.rowIndex
            );
            const end = Math.max(
                range.startRow.rowIndex,
                range.endRow.rowIndex
            );

            for (let rowIndex = start; rowIndex <= end; rowIndex++) {
                const row = allRows[rowIndex]?.data;

                range.columns.forEach(column => {
                    if (column.getColId() === "#") return;

                    const field = column.getColDef().field;
                    const styleKey = field + "_es";

                    if (row?.[styleKey]?.cellStyle?.wrap !== "true") {
                        allWrapped = false;
                    }
                });
            }
        });

        setIsTextWrap(allWrapped);
        return;
    }

    // ======================
    // 4️⃣ SINGLE CELL MODE
    // ======================
    if (focusedCell) {
        const rowData = api.getModel().rootNode.allLeafChildren;
        const field = focusedCell.column.getColDef().field;
        const styleKey = field + "_es";
        const row = rowData[focusedCell.rowIndex]?.data;

        setIsTextWrap(row?.[styleKey]?.cellStyle?.wrap === "true");
    }
};